import {NotificationBaseModel} from '../../shared/models/notification/notification-base.model';

export class NotificationCreationModel extends NotificationBaseModel {
    audienceTeamIds: number[] = new Array();
    userLoginIds: number[] = new Array();
    customerNumberIds: number[] = new Array();
}
